import currentUserSelectAttributes from "./current-user-select.json"

const currentUserSelect = {
  User: currentUserSelectAttributes
}

export default currentUserSelect
